import { extraUsiSchemas } from "./usiFormSchemasRest";

const SIDE_OPTIONS = [
  { value: "", label: "—", labelKey: "usi.lbl.x" },
  { value: "правая", label: "правая", labelKey: "usi.lbl.pravaya" },
  { value: "левая", label: "левая", labelKey: "usi.lbl.levaya" },
];

const ABSENT_PRESENT = [
  { value: "", label: "—", labelKey: "usi.lbl.x" },
  { value: "отсутствует", label: "отсутствует", labelKey: "usi.lbl.otsutstvuet" },
  { value: "имеется", label: "имеется", labelKey: "usi.lbl.imeetsya" },
];

const NO_YES = [
  { value: "", label: "—", labelKey: "usi.lbl.x" },
  { value: "нет", label: "нет", labelKey: "usi.lbl.net" },
  { value: "имеется", label: "имеется", labelKey: "usi.lbl.imeetsya" },
];

const ABSENT_PLURAL = [
  { value: "", label: "—", labelKey: "usi.lbl.x" },
  { value: "отсутствуют", label: "отсутствуют", labelKey: "usi.lbl.otsutstvuyut" },
  { value: "имеются", label: "имеются", labelKey: "usi.lbl.imeyutsya" },
];

const toIsoDate = (value = new Date()) => {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const spectralRows = (arteries) =>
  arteries.flatMap((artery) =>
    [
      { key: "right", label: "Правая", labelKey: "usi.lbl.pravaya_2" },
      { key: "left", label: "Левая", labelKey: "usi.lbl.levaya_2" },
    ].map((side) => ({
      id: `${artery.key}_${side.key}`,
      artery: artery.label,
      arteryKey: artery.labelKey,
      side: side.label,
      sideKey: side.labelKey,
      psv: `${artery.key}_${side.key}_psv`,
      edv: `${artery.key}_${side.key}_edv`,
      spectrum: `${artery.key}_${side.key}_spectrum`,
    })),
  );

const textareaItem = (name, defaultValue, rows = 4) => ({
  name,
  type: "textarea",
  hideLabel: true,
  rows,
  default: defaultValue,
});

const duplexUpperSchema = {
  key: "duplex_upper_arteries",
  label: "УЗИ артерий верхних конечностей", labelKey: "usi.lbl.uzi_arteriy_verhnih_konechnostey",
  title: "Дуплексное сканирование артерий верхних конечностей", titleKey: "usi.lbl.dupleksnoe_skanirovanie_arteriy_verhnih_konechnostey",
  printTitle: "ДУПЛЕКСНОЕ СКАНИРОВАНИЕ АРТЕРИЙ ВЕРХНИХ КОНЕЧНОСТЕЙ", printTitleKey: "usi.lbl.dupleksnoe_skanirovanie_arteriy_verhnih_konechnostey_2",
  blocks: [
    {
      title: "Общая характеристика", titleKey: "usi.lbl.obschaya_harakteristika",
      items: [
        textareaItem(
          "general",
          "Артерии обеих верхних конечностей проходимы на исследованном протяжении.\nСтенки без выраженных структурных изменений. Просветы свободные.\nАтеросклеротические бляшки, тромботические массы и гемодинамически значимые стенозы не выявлены.\nКровоток симметричный, без гемодинамически значимых локальных ускорений.",
          5,
        ),
      ],
    },
    {
      title: "Правая верхняя конечность", titleKey: "usi.lbl.pravaya_verhnyaya_konechnost",
      items: [
        textareaItem(
          "right_limb",
          "Подключичная, подмышечная, плечевая, лучевая и локтевая артерии проходимы.\nКонтуры сосудов ровные. Просветы свободные.\nСпектр кровотока в исследованных сегментах высокорезистентный, мультифазный, без патологического снижения пульсационности.\nГемодинамически значимых перепадов скоростей не выявлено.",
        ),
      ],
    },
    {
      title: "Левая верхняя конечность", titleKey: "usi.lbl.levaya_verhnyaya_konechnost",
      items: [
        textareaItem(
          "left_limb",
          "Подключичная, подмышечная, плечевая, лучевая и локтевая артерии проходимы.\nКонтуры сосудов ровные. Просветы свободные.\nСпектр кровотока в исследованных сегментах высокорезистентный, мультифазный, без патологического снижения пульсационности.\nГемодинамически значимых перепадов скоростей не выявлено.",
        ),
      ],
    },
    {
      type: "spectral_table",
      title: "Спектральные показатели", titleKey: "usi.lbl.spektralnye_pokazateli",
      spectrumLabel: "Спектр", spectrumLabelKey: "usi.lbl.spektr",
      spectrumDefault: "мультифазный",
      rows: spectralRows([
        { key: "subclavian", label: "Подключичная", labelKey: "usi.lbl.podklyuchichnaya" },
        { key: "axillary", label: "Подмышечная", labelKey: "usi.lbl.podmyshechnaya" },
        { key: "brachial", label: "Плечевая", labelKey: "usi.lbl.plechevaya" },
        { key: "radial", label: "Лучевая", labelKey: "usi.lbl.luchevaya" },
        { key: "ulnar", label: "Локтевая", labelKey: "usi.lbl.loktevaya" },
      ]),
    },
    {
      title: "При выявлении стеноза / окклюзии", titleKey: "usi.lbl.pri_vyyavlenii_stenoza_okklyuzii",
      items: [
        { name: "stenosis_segment", label: "Артерия / сегмент", labelKey: "usi.lbl.arteriya_segment", type: "text" },
        {
          name: "stenosis_side",
          label: "Сторона", labelKey: "usi.lbl.storona",
          type: "select",
          options: SIDE_OPTIONS,
        },
        {
          name: "stenosis_lesion_type",
          label: "Характер поражения", labelKey: "usi.lbl.harakter_porazheniya",
          type: "text",
          placeholder:
            "атеросклеротическая бляшка / тромбоз / стеноз / окклюзия / другое",
        },
        {
          name: "stenosis_length_mm",
          label: "Протяженность поражения, мм", labelKey: "usi.lbl.protyazhennost_porazheniya_mm",
          type: "text",
        },
        {
          name: "stenosis_structure",
          label: "Структура / поверхность", labelKey: "usi.lbl.struktura_poverhnost",
          type: "text",
        },
        {
          name: "stenosis_psv_prox",
          label: "PSV проксимальнее поражения, см/с", labelKey: "usi.lbl.psv_proksimalnee_porazheniya_sm_s",
          type: "text",
        },
        {
          name: "stenosis_psv_zone",
          label: "PSV в зоне стеноза, см/с", labelKey: "usi.lbl.psv_v_zone_stenoza_sm_s",
          type: "text",
        },
        {
          name: "stenosis_psv_dist",
          label: "PSV дистальнее, см/с", labelKey: "usi.lbl.psv_distalnee_sm_s",
          type: "text",
        },
        {
          name: "stenosis_psv_ratio",
          label: "Отношение PSV в зоне стеноза к проксимальному сегменту", labelKey: "usi.lbl.otnoshenie_psv_v_zone_stenoza_k_proksimalnomu_segmentu",
          type: "text",
        },
        {
          name: "stenosis_turbulence",
          label: "Постстенотическая турбулентность", labelKey: "usi.lbl.poststenoticheskaya_turbulentnost",
          type: "select",
          options: ABSENT_PRESENT,
        },
        {
          name: "stenosis_occlusion",
          label: "Окклюзия", labelKey: "usi.lbl.okklyuziya",
          type: "select",
          options: ABSENT_PRESENT,
        },
        {
          name: "stenosis_occlusion_length_mm",
          label: "Протяженность окклюзии, мм", labelKey: "usi.lbl.protyazhennost_okklyuzii_mm",
          type: "text",
        },
        {
          name: "stenosis_collateral",
          label: "Коллатеральный кровоток", labelKey: "usi.lbl.kollateralnyy_krovotok",
          type: "text",
        },
      ],
    },
    {
      title: "Заключение", titleKey: "usi.lbl.zaklyuchenie",
      items: [
        textareaItem(
          "conclusion",
          "Ультразвуковых признаков гемодинамически значимого поражения артерий верхних конечностей не выявлено. Артерии проходимы на исследованном протяжении. Гемодинамически значимые стенозы и окклюзии не определяются.",
          5,
        ),
      ],
    },
  ],
};

const duplexLowerSchema = {
  key: "duplex_lower_arteries",
  label: "УЗИ артерий нижних конечностей", labelKey: "usi.lbl.uzi_arteriy_nizhnih_konechnostey",
  title: "Дуплексное сканирование артерий нижних конечностей", titleKey: "usi.lbl.dupleksnoe_skanirovanie_arteriy_nizhnih_konechnostey",
  printTitle: "ДУПЛЕКСНОЕ СКАНИРОВАНИЕ АРТЕРИЙ НИЖНИХ КОНЕЧНОСТЕЙ", printTitleKey: "usi.lbl.dupleksnoe_skanirovanie_arteriy_nizhnih_konechnostey_2",
  blocks: [
    {
      title: "Общая характеристика", titleKey: "usi.lbl.obschaya_harakteristika",
      items: [
        textareaItem(
          "general",
          "Артерии обеих нижних конечностей проходимы на исследованном протяжении.\nСтенки без выраженных структурных изменений. Просветы свободные.\nАтеросклеротические бляшки и гемодинамически значимые стенозы не выявлены.\nКровоток симметричный, без гемодинамически значимых локальных ускорений.",
          5,
        ),
      ],
    },
    {
      title: "Правая нижняя конечность", titleKey: "usi.lbl.pravaya_nizhnyaya_konechnost",
      items: [
        textareaItem(
          "right_limb",
          "Общая бедренная, глубокая бедренная, поверхностная бедренная, подколенная, передняя и задняя большеберцовые артерии, тыльная артерия стопы проходимы.\nСпектр кровотока в проксимальных сегментах мультифазный, с сохранением нормальной высокорезистентной формы; дистально — без патологического снижения пульсационности.\nГемодинамически значимых перепадов скоростей не выявлено.",
        ),
      ],
    },
    {
      title: "Левая нижняя конечность", titleKey: "usi.lbl.levaya_nizhnyaya_konechnost",
      items: [
        textareaItem(
          "left_limb",
          "Общая бедренная, глубокая бедренная, поверхностная бедренная, подколенная, передняя и задняя большеберцовые артерии, тыльная артерия стопы проходимы.\nСпектр кровотока в проксимальных сегментах мультифазный, с сохранением нормальной высокорезистентной формы; дистально — без патологического снижения пульсационности.\nГемодинамически значимых перепадов скоростей не выявлено.",
        ),
      ],
    },
    {
      type: "spectral_table",
      title: "Спектральные показатели", titleKey: "usi.lbl.spektralnye_pokazateli",
      spectrumLabel: "Характер спектра", spectrumLabelKey: "usi.lbl.harakter_spektra",
      spectrumDefault: "мультифазный",
      rows: spectralRows([
        { key: "cfa", label: "Общая бедренная", labelKey: "usi.lbl.obschaya_bedrennaya" },
        { key: "sfa_prox", label: "Поверхностная бедренная (прокс.)", labelKey: "usi.lbl.poverhnostnaya_bedrennaya_proks" },
        { key: "sfa_dist", label: "Поверхностная бедренная (дист.)", labelKey: "usi.lbl.poverhnostnaya_bedrennaya_dist" },
        { key: "popliteal", label: "Подколенная", labelKey: "usi.lbl.podkolennaya" },
        { key: "ata", label: "Передняя большеберцовая", labelKey: "usi.lbl.perednyaya_bolshebercovaya" },
        { key: "pta", label: "Задняя большеберцовая", labelKey: "usi.lbl.zadnyaya_bolshebercovaya" },
        { key: "dpa", label: "Тыльная артерия стопы", labelKey: "usi.lbl.tylnaya_arteriya_stopy" },
      ]),
    },
    {
      title: "При выявлении стеноза / окклюзии", titleKey: "usi.lbl.pri_vyyavlenii_stenoza_okklyuzii",
      items: [
        { name: "stenosis_segment", label: "Артерия / сегмент", labelKey: "usi.lbl.arteriya_segment", type: "text" },
        {
          name: "stenosis_side",
          label: "Сторона", labelKey: "usi.lbl.storona",
          type: "select",
          options: SIDE_OPTIONS,
        },
        {
          name: "stenosis_plaque",
          label:
            "Бляшка: локализация, протяженность, эхоструктура, поверхность",
          type: "textarea",
          rows: 2,
        },
        {
          name: "stenosis_diameter_pct",
          label: "Диаметр редуцирован на, %", labelKey: "usi.lbl.diametr_reducirovan_na",
          type: "text",
        },
        {
          name: "stenosis_psv_before",
          label: "PSV до стеноза, см/с", labelKey: "usi.lbl.psv_do_stenoza_sm_s",
          type: "text",
        },
        {
          name: "stenosis_psv_zone",
          label: "PSV в зоне стеноза, см/с", labelKey: "usi.lbl.psv_v_zone_stenoza_sm_s",
          type: "text",
        },
        {
          name: "stenosis_psv_after",
          label: "PSV после стеноза, см/с", labelKey: "usi.lbl.psv_posle_stenoza_sm_s",
          type: "text",
        },
        {
          name: "stenosis_velocity_ratio",
          label: "Отношение скоростей в зоне стеноза / проксимальном сегменте", labelKey: "usi.lbl.otnoshenie_skorostey_v_zone_stenoza_proksimalnom_segmente",
          type: "text",
        },
        {
          name: "stenosis_post_changes",
          label: "Постстенотические изменения", labelKey: "usi.lbl.poststenoticheskie_izmeneniya",
          type: "select",
          options: ABSENT_PLURAL,
        },
        {
          name: "stenosis_post_note",
          label: "Уточнение постстенотических изменений", labelKey: "usi.lbl.utochnenie_poststenoticheskih_izmeneniy",
          type: "text",
        },
        {
          name: "stenosis_occlusion",
          label: "Окклюзия", labelKey: "usi.lbl.okklyuziya",
          type: "select",
          options: NO_YES,
        },
        {
          name: "stenosis_occlusion_length_mm",
          label: "Протяженность окклюзии, мм", labelKey: "usi.lbl.protyazhennost_okklyuzii_mm",
          type: "text",
        },
        {
          name: "stenosis_collateral",
          label: "Коллатеральный кровоток", labelKey: "usi.lbl.kollateralnyy_krovotok",
          type: "text",
        },
      ],
    },
    {
      title: "Заключение", titleKey: "usi.lbl.zaklyuchenie",
      items: [
        textareaItem(
          "conclusion",
          "Ультразвуковых признаков гемодинамически значимого поражения артерий нижних конечностей не выявлено. Артерии проходимы на исследованном протяжении. Гемодинамически значимые стенозы и окклюзии не определяются.",
          5,
        ),
      ],
    },
  ],
};

const USI_SCHEMA_LIST = [
  duplexUpperSchema,
  duplexLowerSchema,
  ...extraUsiSchemas,
];

const USI_FORM_SCHEMAS = {};

// 1) label — публичное название: оно же значение в списке и то, что пишется
//    в diagnostics.name. Вместе с key это главные ключи поиска.
USI_SCHEMA_LIST.forEach((schema) => {
  if (schema.label) USI_FORM_SCHEMAS[schema.label] = schema;
  USI_FORM_SCHEMAS[schema.key] = schema;
});

// 2) title — запасной ключ для протоколов, сохранённых под старым названием
//    типа. Добавляется только если строка свободна, иначе title одной схемы
//    перекрыл бы label другой (например «УЗИ вен нижних конечностей»).
USI_SCHEMA_LIST.forEach((schema) => {
  if (schema.title && !USI_FORM_SCHEMAS[schema.title]) {
    USI_FORM_SCHEMAS[schema.title] = schema;
  }
});

// Состав списка типов «Добавить УЗИ» — задаётся ключами схем.
// Порядок отображения не зависит от этого массива: названия сортируются
// по алфавиту ниже (русская локаль).
const USI_TYPE_ORDER = [
  "duplex_upper_arteries",
  "duplex_lower_arteries",
  "duplex_aorta",
  "duplex_bca",
  "bca_standard",
  "duplex_upper_veins",
  "duplex_lower_veins",
  "duplex_renal_arteries",
  "urinary_complex",
  "urinary_tract",
  "abdomen",
  "abdomen_retroperitoneum",
  "abdomen_gobeciya",
  "kidneys_adrenals",
  "trus_prostate",
  "breast_standard",
  "breast_birads",
  "pelvis_standard",
  "pelvis_female",
  "scrotum",
  "lower_veins_standard",
  "liver_biliary",
  "lymph_nodes",
  "prostate_ta",
  "joints",
  "thyroid_parathyroid",
  "thyroid_eutirads",
];

// Названия берутся из label схем — единственный источник правды,
// чтобы список, значение для БД и ключ схемы не расходились.
// Сортируем по алфавиту (русская локаль) для удобства выбора в селекторе.
export const USI_TYPE_LABELS = USI_TYPE_ORDER.map(
  (key) => USI_FORM_SCHEMAS[key]?.label || key,
).sort((a, b) => a.localeCompare(b, "ru"));

export const USI_TYPE_OPTIONS = USI_TYPE_LABELS.map((label) => ({
  value: label,
  label,
}));

// Тот же список, но с переведёнными названиями для интерфейса.
// value остаётся русским: именно оно уходит на сервер и пишется в
// diagnostics.name.
export function getUsiTypeOptions(t) {
  if (typeof t !== "function") return USI_TYPE_OPTIONS;
  return USI_TYPE_ORDER.map((key) => USI_FORM_SCHEMAS[key])
    .filter(Boolean)
    .map((schema) => ({
      value: schema.label,
      label:
        schema.labelKey && t(schema.labelKey) !== schema.labelKey
          ? t(schema.labelKey)
          : schema.label,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
}

export function getUsiFormSchema(typeOrKey) {
  const raw = String(typeOrKey ?? "").trim();
  if (!raw) return null;
  return USI_FORM_SCHEMAS[raw] || null;
}

export function getUsiTypeParam(typeOrKey) {
  const schema = getUsiFormSchema(typeOrKey);
  return schema?.key || String(typeOrKey ?? "").trim();
}

export function isUsiDiagnostics(row) {
  // usi_id надёжнее названия: протоколы, сохранённые под старым названием
  // типа, тоже остаются УЗИ и открываются через форму УЗИ.
  if (Number(row?.usi_id) > 0) return true;
  const type = String(row?.type_diagnostics ?? "")
    .trim()
    .toLowerCase();
  if (type === "usi" || type === "узи") return true;
  return USI_TYPE_LABELS.includes(String(row?.name ?? "").trim());
}

export function isUsiConclusionBlock(block) {
  return (
    String(block?.title || "")
      .trim()
      .toLowerCase() === "заключение"
  );
}

export function isUsiRecommendationsBlock(block) {
  return (
    String(block?.title || "")
      .trim()
      .toLowerCase() === "рекомендации"
  );
}

export function getUsiResultBlocks(schema) {
  const blocks = schema?.blocks || [];
  const index = blocks.findIndex(isUsiConclusionBlock);
  if (index === -1) return blocks;
  return blocks.slice(0, index);
}

export function getUsiConclusionBlock(schema) {
  return (schema?.blocks || []).find(isUsiConclusionBlock) || null;
}

export function buildUsiFormDefaults(schema) {
  const data = {
    study_date: toIsoDate(new Date()),
    indications: "",
    doctor: "",
    doctor_id: "",
    conclusion: "",
    recommendations: "",
    followup_term: "",
    followup_purpose: "",
  };

  if (!schema) return data;

  (schema.headerItems || []).forEach((item) => {
    if (!item?.name) return;
    data[item.name] = item.default ?? "";
  });

  (schema.blocks || []).forEach((block) => {
    if (block.type === "spectral_table") {
      (block.rows || []).forEach((row) => {
        data[row.psv] = "";
        data[row.edv] = "";
        data[row.spectrum] = block.spectrumDefault || "мультифазный";
      });
      return;
    }

    if (block.type === "table") {
      (block.rows || []).forEach((row) => {
        (block.columns || []).forEach((col) => {
          if (col.readOnly) return;
          data[`${row.id}_${col.key}`] = row.defaults?.[col.key] ?? "";
        });
      });
      return;
    }

    (block.items || []).forEach((item) => {
      if (!item?.name) return;
      data[item.name] = item.default ?? "";
    });
  });

  return data;
}
